import { useState, useContext } from 'react'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import LeftNavigation from '../../common/leftNavigation';


export default function SavingsLeftNavigation({ clickAnalytics, navItems }: any) {
    const dispatch: any = useContext(DataDispatchContext)
    const data: any = useContext(DataContext)
    const [selected, setSelected] = useState(data?.savingsSelected);
 
    const handleMenuClick = (event: any) => {
      const id = event.currentTarget.id
      setSelected(id)
      dispatch({
          type: 'setSavingsSelected',
          selected: id
        })
        clickAnalytics(id)
      }


    const navItemList = (navItems || []).map((item: any)=>(
      {
        ...item,
        action: handleMenuClick
      }
    ))
    

    return (
      <LeftNavigation 
        itemSelected={selected}
        defaultSelected={"SR2023"} 
        title={"Savings"} 
        navItemList={navItemList}
        menuDisplay={{ 
          xs: 'none', 
          sm: data.rightPanel?'none':'flex', 
          md: 'flex', 
          lg: 'flex'
        }}
      />
    )
}